import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Input} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';

class CodeInput extends Component {
  handleCodeChange(index, event, data) {
    const {name, value} = data;
    this.props.changeProviderDetailElementValue(index, name, value.toUpperCase());
  }

  handleCodeBlur(order, index) {
    const {detail, mainOrder} = this.props;
    const repeatedIndex = detail.findIndex((element, currentIndex) =>
      element.partCode === order.partCode && currentIndex !== index);

    if (repeatedIndex !== -1) {
      this.props.addMessageBoxError(
        `El repuesto ${order.partCode}, ya se encuentra en el pedido en la línea ${repeatedIndex + 1}.`
      );
      return;
    }

    if (order.partCode) {
      this.props.checkProviderStockOrderCode(order, {'type': index, 'provider': mainOrder.providerCode});
    }
  }

  render() {
    const {order, index} = this.props;

    if (!order.active) {
      return order.partCode;
    }

    return (
      <Input required
        className='part-code'
        name='partCode'
        maxLength='20'
        size='small'
        value={order.partCode}
        onChange={this.handleCodeChange.bind(this, index)}
        onBlur={this.handleCodeBlur.bind(this, order, index)}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'detail': state.providersOrdersManagementDetail.list,
    'mainOrder': state.providersOrdersManagementDetail.selectedOrder,
  };
};

const {
  addMessageBoxError,
  changeProviderDetailElementValue,
  checkProviderStockOrderCode,
} = Actions;

export default connect(mapStateToProps, {
  addMessageBoxError,
  changeProviderDetailElementValue,
  checkProviderStockOrderCode,
})(CodeInput);
